export default __webpack_public_path__ + "static/media/poster.f5f43b67.jpg";